import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import SimpleReactLightbox from 'simple-react-lightbox'
import Header from "./header"
import Footer from "./footer"

import "./styles.scss"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
      kontentItemGlobalSettings {
        elements {
          disclaimer {
            value
          }
          links {
            value {
              ... on kontent_item_footer_link {
                elements {
                  text {
                    value
                  }
                  url {
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  return (
    <>
    <SimpleReactLightbox>
      <Header />
      <main>{children}</main>
      <Footer
        siteDisclaimer={
          data.kontentItemGlobalSettings.elements.disclaimer.value
        }
        siteFooterLinks={
          data.kontentItemGlobalSettings.elements.links.value
        }
      />
      </SimpleReactLightbox>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
